import { config } from '../../appConfig'
import { GAUserContext } from '../../interfaces/googleAnalytics'

export const deviceInfo = {
  language: navigator.language,
  platform: config.fetchEnv('GA_PLATFORM') as GAUserContext['platform'],
  version: config.fetchEnv('APP_VERSION'),
}
